import { PRODUCT_IMAGE_SIZE } from 'components/BrandComponents/BrandCataloguesPage/constants';
import { EntityType } from 'types/common';

export const DEFAULT_AVATAR_SIZE = 40;

export const AVATAR_SIZE: Record<EntityType, number> = {
  brands: DEFAULT_AVATAR_SIZE,
  points: DEFAULT_AVATAR_SIZE,
  products: PRODUCT_IMAGE_SIZE,
  catalogues: DEFAULT_AVATAR_SIZE,
  'points-categories': 16,
  'product-categories': 16,
};
